import { createElement } from 'react';
import './style.less';
function BodyDemo(props) {
    const { title, subTitle1, subDesc, subTitle2, attribute1, attribute2, attribute3, attribute4, } = props.data;
    const { subTitle1Style, onPress } = props;
    return (createElement("div", { className: "card-demo", onClick: onPress },
        Boolean(title) && createElement("div", { className: "TITLE" }, title),
        createElement("div", { className: "content" },
            createElement("div", { className: "top" },
                createElement("div", { className: "subTitle1", style: subTitle1Style }, subTitle1),
                createElement("div", { className: "subtitle2" }, subTitle2)),
            createElement("div", { className: "bottom" },
                createElement("div", { className: 'subTitle1-desc' }, subDesc),
                createElement("div", { className: 'attribute' },
                    createElement("span", null,
                        attribute1,
                        " "),
                    attribute2 && createElement("div", { className: 'attribute-line' }),
                    createElement("span", null,
                        attribute2,
                        " "),
                    attribute3 && createElement("div", { className: 'attribute-line' }),
                    createElement("span", null,
                        attribute3,
                        " ")))),
        createElement("div", { className: "footer" }, attribute4)));
}
const ProductList = (props) => {
    const { data, subTitle1Style, onPress, } = props;
    return (createElement(BodyDemo, { data: data, onPress: onPress, subTitle1Style: subTitle1Style }));
};
export default ProductList;
